import yeatiImage from "@/assets/simple-yeati-transparent.png";
import { SidebarMenuButton } from "@/shared/ui/Sidebar";

type SidebarOrganizationInfoProps = {
  organizationName?: string
  external_id?: string
  collapsed: boolean
};

const SidebarOrganizationInfo = ({ organizationName, external_id, collapsed }: SidebarOrganizationInfoProps) => {
  return (
    <SidebarMenuButton
      size="lg"
      asChild
      className="hover:!bg-transparent"
    >
      <div>
        <div className="text-sidebar-primary-foreground flex aspect-square size-10 items-center justify-center rounded-lg relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[oklch(0.93_0.05_240)] via-[oklch(0.84_0.12_280)] to-[oklch(0.9_0.18_320)] animate-gradient-shift" />
          <div className="w-full h-full flex items-center justify-center relative z-10">
            <img
              src={yeatiImage}
              alt="logo"
              className="w-8 h-8 object-contain"
            />
          </div>
        </div>
        {!collapsed && (
          <div className="grid flex-1 text-left text-lg leading-tight">
            <span className="truncate font-medium">{organizationName}</span>
            <div className="text-xs text-gray-400 text-left">
              <span>{external_id}</span>
            </div>
          </div>
        )}
      </div>
    </SidebarMenuButton>
  );
};

export default SidebarOrganizationInfo;
